export default __webpack_public_path__ + "static/media/running-free.aca27db9.jpg";